import { FilterMatchMode } from "primereact/api";
import { Tag } from "primereact/tag";

export class ConfiguracionArchivo {

    model = {
        id: {
            value: null, header: 'Código', export: true, table: true, sort: true, filter: true, filterField: 'id', filterPlaceholder: 'ID',
            isNumeric: true, matchMode: FilterMatchMode.EQUALS, headerStyle: { width: '9rem', minWidth: '9rem' },
            body: (rowData) => (
                <span className="font-semibold text-blue-700 bg-blue-50 px-2 py-1 border-round text-sm">
                    #{rowData.id}
                </span>
            )
        },
        orden: {
            value: 1, export: true, header: 'Orden', required: 'Orden es requerido', table: true, max: 1000, min: 1, minLength: 'Mínimo 1', maxLength: 'Máximo 1000',
            filterField: 'orden', filter: true, sort: true, filterPlaceholder: 'Orden', isNumeric: true,
            matchMode: FilterMatchMode.EQUALS, headerStyle: { width: '9rem', minWidth: '9rem' },
            body: (rowData) => (
                <span className="font-bold text-700 bg-gray-100 border-circle w-2rem h-2rem inline-flex align-items-center justify-content-center text-sm">
                    {rowData.orden}
                </span>
            )
        },
        nombre: {
            value: '', export: true, header: 'Nombre / Tipo adjunto', required: false, maxLength: 'Máximo 500 caracteres',
            table: true, minLength: 'Mínimo 4 caracteres', max: 500, min: 4, filterField: 'nombre', filter: true, sort: true,
            matchMode: FilterMatchMode.CONTAINS, filterPlaceholder: 'Buscar archivo...', headerStyle: { width: '35%', minWidth: '18rem' },
            body: (rowData) => (
                <div className="flex align-items-center">
                    <i className="pi pi-file mr-2 text-primary-400"></i>
                    <span className="font-semibold text-800 text-sm">{rowData.nombre}</span>
                </div>
            )
        },
        tipo_adjunto: {
            value: null, export: false, required: false, header: 'Tipo de adjunto', table: false, filter: false, sort: true, matchMode: FilterMatchMode.CONTAINS,
            filterField: 'tipo_adjunto', headerStyle: { width: '10%', minWidth: '10rem' }
        },
        tipo_formulario: {
            value: null, export: false, required: 'Seleccione', header: 'Tipo de formulario', table: true, filter: true,
            sort: true, matchMode: FilterMatchMode.CONTAINS, filterField: 'tipo_formulario', filterPlaceholder: 'Buscar formulario...',
            headerStyle: { width: '25%', minWidth: '16rem' },
            body: (rowData) => (
                <div className="flex align-items-center text-700 text-sm">
                    <i className="pi pi-list mr-2 text-500"></i>
                    <span className="font-semibold">{typeof rowData.tipo_formulario === 'object' ? rowData.tipo_formulario?.nombre : rowData.tipo_formulario}</span>
                </div>
            )
        },
        obligatorio: {
            header: '¿Archivo obligatorio?', value: null, required: 'Campo requerido', optionLabel: 'nombre', table: true,
            export: true, filter: true, filterField: 'obligatorio', filterPlaceholder: 'Buscar...', matchMode: FilterMatchMode.CONTAINS,
            headerStyle: { width: '12rem', minWidth: '12rem' },
            body: (rowData) => (
                <Tag value={rowData.obligatorio} severity={rowData.obligatorio === 'SI' ? 'danger' : 'info'} className="text-xs px-2 py-1 font-semibold" rounded />
            )
        },
        es_revision: {
            header: '¿Es para revisión?', value: null, required: 'Campo requerido', optionLabel: 'nombre', export: true, table: true,
            filter: true, sort: true, filterField: 'es_revision', filterPlaceholder: 'Buscar...', matchMode: FilterMatchMode.CONTAINS,
            headerStyle: { width: '12rem', minWidth: '12rem' },
            body: (rowData) => (
                <Tag value={rowData.es_revision} severity={rowData.es_revision === 'SI' ? 'warning' : 'secondary'} className="text-xs px-2 py-1 font-semibold" rounded />
            )
        },
        nemonicos_obligatorio: {
            value: '', export: true, header: 'Nemónicos', required: false, maxLength: 'Máximo 500 caracteres', table: false,
            minLength: 'Mínimo 3 caracteres', max: 500, min: 3, filterField: 'formula1', filter: false,
        },
        extension_valida: {
            value: '', export: true, header: 'Extensiones válidas', required: false, maxLength: 'Máximo 300 caracteres', table: false,
            minLength: 'Mínimo 3 caracteres', max: 500, min: 3, filterField: 'extension_valida', filter: false,
            headerStyle: { width: '30%', minWidth: '20rem' }
        },
        mostrar_anexo: { value: null, label: 'Mostrar en lista de anexos', rules: { required: 'El campo es requerido' }, header: 'Mostrar Anexo', table: false, },
        estado: { header: 'Estado', value: { nombre: 'Activo', cat_id: true }, required: 'Estado es requerido', optionLabel: 'nombre', export: true, table: false },
    }
    optionLabel = 'nombre'
}
